import { tw } from "@noones/ui/tw";
import { Header } from "./sections/Header";
import React from "react";
import { Volume } from "./sections/Volume/Volume";
import { Status } from "./sections/Status/Status";

export const StatusPage = () => (
    <div className={tw.flex.flex_col.items_center.bg_light_grey.h_full.pb_20}>
        <Header />
        <div
            className={tw.flex.flex_col_reverse.items_center.w_full.gap_12.w_full.px_4.max_w_[
                "1032px"
            ].lg(tw.flex_row.justify_center.items_start)}
        >
            <Volume />
            <Status />
        </div>
    </div>
);
